var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.selectedClass + 'hour',on:{"click":_vm.selectHour}},[_c('p',{staticClass:"sm-text"},[_vm._v(" "+_vm._s(_vm.data)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }